<template>
  <div id="invoiceDetail">
    <div class="title">
      <p class="name">发票详情<span class="back" @click="back()" v-if="isApp!==2">返回<i class="backIcon">></i></span></p>
    </div>

    <div class="bill-center-top" :style="{marginBottom:tabHeight>65?'40px':'20px'}">
        <div class="title_div">
            <p>{{detail.tails.invoice_state}}</p>
            <p>{{detail.tails.invoice_state=="已开具"?"发票正在马不停蹄得飞向您！":"发票还在开具中，请耐心等待哟！"}}</p>
            <img src="./images/ic_fp_a.png" alt="" srcset="">
        </div>
        <div class="inv_list">
            <div class="inv_title">发票信息</div>
            <div class="inv_title_comm">
                <p>发票号</p>
                <p>{{detail.invoice_number}}</p>
            </div>
            <div class="inv_title_comm">
                <p>开票抬头</p>
                <p>{{detail.invoice_rise}}</p>
            </div>
            <div class="inv_title_comm">
                <p>开票时间</p>
                <p>{{detail.tails.create_time}}</p>
            </div>
            <div class="inv_title_comm">
                <p>开票金额</p>
                <p>￥{{detail.invoice_money/100}}</p>
            </div>
        </div>
        <div class="inv_list inv_list_t">
            <div class="inv_title">物流信息</div>
            <div class="inv_title_comm">
                <p>物流公司</p>
                <p>{{(detail.express_company||detail.express_company)==""?"暂无物流信息":detail.express_company}}</p>
            </div>
            <div class="inv_title_comm">
                <p>物流单号</p>
                <p>{{detail.express_number}}</p>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import { Dialog } from 'vant'
import { Toast } from 'mint-ui'
import wxshare from '../../../wx/weixin'
export default {
  components: {

  },
  data () {
    return {
      tabHeight: 65,
      orderId: '',
      detail: '',
      isApp : 0
    }
  },
  created () {
    this.orderId = this.$route.query.orderId
    this.getDetail()
    this.isApp = parseInt(localStorage.getItem("isApp"))
  },
  methods: {
    back () {
      this.$router.back(-1)
    },
    getDetail () {
      let obj = {
        id: this.orderId
      }
      this.utils.get(this.companyUrl + '/invoice/detail', obj, res => {
        this.detail = res.data
      })
    }
  },
  computed: {

  },
  watch: { // 通过监听去改变按钮的颜色

  }
}
</script>

<style scoped lang="scss">
#invoiceDetail{
    width: 100%;
    min-height: 100vh;
    background: #f4f4f4;
}
.bill-center-top {
  top: 50px;
  position: relative;
  .inv_list_t{
      margin-top: 10px;
  }
  .inv_list{
      background: #fff;
      .inv_title{
          height: 45px;
          line-height: 45px;
          font-weight: bold;
          font-size: 15px;
          border-bottom: 1px solid #EEEEEE;
          padding: 0 15px;
          margin-bottom: 10px;
      }
      .inv_title_comm{
          display: flex;
          font-size: 14px;
          padding: 0 15px;
          line-height: 28px;
          p:nth-child(1){
              color: #BEBEBE;
              width: 80px;
          }
          p:nth-child(2){
              color: #000000;
          }
      }
      .inv_title_comm:last-child{
          padding-bottom: 15px;
      }
  }
  .title_div{
    height: 105px;
    background: #C41335;
    padding: 15px;
    position: relative;
    p:nth-child(1){
        font-size: 24px;
        color: #fff;
        font-weight: bold;
        margin-top: 10px;
    }
    p:nth-child(2){
        font-size: 14px;
        color: #fff;
    }
    >img{
        width: 80px;
        height: 70px;
        position: absolute;
        bottom: 0;
        right: 0;
    }
    }
}

.title {
  height: 50px;
  line-height: 50px;
  width: 100%;
  padding: 0 13px 0 13px;
  background: #C41335;
  position: fixed;
  top: 0;
  z-index: 2;
  color: #fff;
  /* border-bottom-style: solid;
  border-bottom-color: #f2f2f2;
  border-bottom-width: 1px; */
}
.name {
  font-size: 15px;
  color: #fff;
  font-weight: bold;
}
.back {
  float: right;
  font-size: 13px;
  color: #fff;
}
.backIcon {
  display: inline-block;
  vertical-align: top;
  margin-left: 5px;
  font-size: 13px;
  color: #fff;
}
body {
  background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/personCenter/invoiceDetail.vue